export default "__VITE_ASSET__c1249f5b__"